import { useParams, useNavigate } from 'react-router-dom';
import HeritageTheme from './themes/HeritageTheme'
import ModernTheme from './themes/ModernTheme';
import WarmTheme from './themes/WarmTheme';
import TechTheme from './themes/TechTheme';

// Phase 1: static school data — replace with API call in Phase 2
const SCHOOLS = {
  'saint-hood-convent': {
    slug: 'saint-hood-convent',
    name: 'Saint Hood Convent School',
    tagline: 'Nurturing Excellence Since 1968',
    motto: '"Sapientia et Virtus"',
    address: '14, Civil Lines, Ghaziabad — 201001',
    phone: '+91 120 2724400',
    email: 'admissions@sainthoodconvent.edu.in',
    board: 'CBSE',
    establishedYear: 1968,
    websiteTheme: 'heritage',
    logo: null,
    stats: { students: '3,200+', staff: 180, results: '98.4%', alumni: '45,000+' },
    academic: { grades: ['I','II','III','IV','V','VI','VII','VIII','IX','X','XI','XII'] },
    streams: ['Science', 'Commerce', 'Humanities'],
    affiliation: 'CBSE Affiliation No. 2730189',
  },
  'greensprings-modern': {
    slug: 'greensprings-modern',
    name: 'Greensprings Modern School',
    tagline: 'Where Great Futures Begin',
    motto: 'Learn. Lead. Excel.',
    address: 'Sector 62, Noida — 201309',
    phone: '+91 120 4567890',
    email: 'hello@greensprings.edu.in',
    board: 'CBSE',
    establishedYear: 2006,
    websiteTheme: 'modern',
    logo: null,
    stats: { students: '2,800+', staff: 280, results: '97%', alumni: '12,000+' },
    academic: { grades: ['KG','I','II','III','IV','V','VI','VII','VIII','IX','X','XI','XII'] },
    streams: ['Science', 'Commerce', 'Humanities'],
    affiliation: 'CBSE Affiliation No. 531002',
  },
  'sunrise-valley': {
    slug: 'sunrise-valley',
    name: 'Sunrise Valley School',
    tagline: 'Every Child, Every Day',
    motto: '"A place where every child belongs"',
    address: 'Sector 14, Dwarka, New Delhi — 110078',
    phone: '+91 98765 43210',
    email: 'hello@sunrisevalley.edu.in',
    board: 'CBSE',
    establishedYear: 2008,
    websiteTheme: 'warm',
    logo: null,
    stats: { students: '1,400+', staff: 95, results: '96%', alumni: '8,000+' },
    academic: { grades: ['Nursery','KG','I','II','III','IV','V','VI','VII','VIII','IX','X'] },
    streams: ['General'],
    affiliation: 'CBSE Affiliation No. 2730801',
  },
  'nexgen-academy': {
    slug: 'nexgen-academy',
    name: 'NexGen Academy',
    tagline: 'Code the Future. Build the World.',
    motto: '// Where STEM meets ambition',
    address: 'DLF Cyber City, Gurugram — 122002',
    phone: '+91 124 4567890',
    email: 'admissions@nexgenacademy.edu.in',
    board: 'CBSE',
    establishedYear: 2012,
    websiteTheme: 'tech',
    logo: null,
    stats: { students: '2,400+', staff: 180, results: '99%', alumni: '6,000+' },
    academic: { grades: ['I','II','III','IV','V','VI','VII','VIII','IX','X','XI','XII'] },
    streams: ['Science + CS', 'Commerce + Fintech'],
    affiliation: 'CBSE Affiliation No. 2730999',
  },
};

const THEMES = {
  heritage: HeritageTheme,
  modern:   ModernTheme,
  warm:     WarmTheme,
  tech:     TechTheme,
};

export default function SchoolWebsite() {
  const { slug } = useParams();
  const navigate = useNavigate();

  // Phase 1: pull from static map
  // Phase 2: replace with → fetch(`/api/public/school/${slug}`)
  const school = SCHOOLS[slug];

  if (!school) {
    navigate('/404');
    return null;
  }

  const Theme = THEMES[school.websiteTheme] || ModernTheme;
  return <Theme school={school} />;
}